import script from "./ProjectFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectFilter.vue?vue&type=script&setup=true&lang=js"

import "./ProjectFilter.vue?vue&type=style&index=0&id=b9bd7c76&lang=css"

const __exports__ = script;

export default __exports__